import { render, staticRenderFns } from "./SendQ.vue?vue&type=template&id=7cb519d1&"
import script from "./SendQ.vue?vue&type=script&lang=js&"
export * from "./SendQ.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports